import "./ConfirmModal.scss";

import { observer } from "mobx-react";
import React from "react";
import { useForm } from "react-hook-form";
import { Auth } from "src/domain_v2/auth";

import { modalStore, WarningModal } from "..";

type Props = {
  guide: React.ReactNode;
  onConfirm: () => void;
};

type FormData = {
  password: string;
};

const ConfirmModal = ({ guide, onConfirm }: Props) => {
  const { register, handleSubmit } = useForm<FormData>();

  const onSubmit = async (data: FormData) => {
    const onError = () => {
      modalStore.openModal(
        <WarningModal
          text={"비밀번호가 틀렸습니다."}
          onConfirm={() => modalStore.closeModal()}
        />
      );
    };

    try {
      const isConfirmed = await Auth.authService.confirmPassword(data.password);

      if (!isConfirmed) {
        throw new Error();
      }

      onConfirm();
    } catch (error) {
      onError();
    }
  };

  return (
    <div className="confirm__modal">
      <div className="guide__text">{guide}</div>
      <form onSubmit={handleSubmit(onSubmit)} className="confirm__form">
        <input
          type="password"
          {...register("password")}
          className="form__input"
          placeholder="비밀번호를 입력해주세요."
        />
        <div className="form__button--wrap">
          <button
            type="reset"
            className="form__button--reset"
            onClick={() => modalStore.closeModal()}
          >
            취소
          </button>
          <button type="submit" className="form__button--submit">
            확인
          </button>
        </div>
      </form>
    </div>
  );
};

export default observer(ConfirmModal);
